<script setup>
import { useRoute } from 'vue-router'
import { useCartStore } from './stores/CartStore';
import { onErrorCaptured, watch } from 'vue';
import BaseLayout from './layouts/BaseLayout.vue';
import { ref } from 'vue';
import { useSystemStore } from './stores/SystemStore';

const cartStore = useCartStore()
const route = useRoute()
const systemStore = useSystemStore()

// Atualiza o carrinho quando houver mudança no localStorage
window.addEventListener('storage', (event) => {
  if (event.key === 'cart') {
    cartStore.$patch(JSON.parse(event.newValue));
  }
});

// atualiza o título da página
watch(
  () => route.meta.title,
  (newTitle) => {
    if (newTitle) {
      document.title = newTitle
    }
  },
  { immediate: true }
)

const errorState = ref(null);
onErrorCaptured((error) => {
  errorState.value = error;
  return true
})


const Retry = () => {
  errorState.value = null;
};

</script>

<template>
  <v-container v-if="errorState">
    <v-empty-state
      headline="Ops! Algo deu errado."
      :title="errorState.message"
      text="Clique no botão abaixo para tentar novamente."
    >
      <template #actions>
        <v-btn class="text-none" text="Tentar novamente" @click="Retry"/>
      </template>
    </v-empty-state>
  </v-container>
  <Suspense v-else>
    <template #default>
      <BaseLayout />
    </template>
  </Suspense>
  <v-overlay :scroll-strategy="'none'"
      persistent
      :model-value="systemStore.isLoadingGlobal"
      class="align-center justify-center"
      >
    <v-progress-circular
      color="primary"
      size="64"
      indeterminate
    ></v-progress-circular>
  </v-overlay>
  <!-- <RouterView /> -->
</template>

<style scoped>
.error-container {
  color: red;
  border: 1px solid red;
  padding: 10px;
  border-radius: 5px;
}
</style>
